module.exports = __webpack_public_path__ + "static/ufo_title-f7956b939f1c4deecf8158d6dda176c3.png";